import { Component, OnInit } from '@angular/core';
import { InitializationService } from '../../services/initialization.service';
import { CurrentInfoService } from '../../services/current-info.service';
import { WorkWeekService } from '../../services/work-week.service';
import { AppConfigService } from '../../services/app-config.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { CustomerService } from 'src/app/services/customer.service';
import { CurrentOrderService } from 'src/app/services/current-order.service';
import { Title, Meta } from '@angular/platform-browser';
import { LocaleService } from 'src/app/services/locale.service';
import { StoreHistoryService } from 'src/app/services/store-history-service.service';

@Component({
  selector: 'app-table-order',
  templateUrl: './table-order.component.html',
  styleUrls: ['./table-order.component.scss'],
})
export class TableOrderComponent implements OnInit {
  constructor(
    private initializationservice: InitializationService,
    private currentinfoservice: CurrentInfoService,
    private workweekservice: WorkWeekService,
    private appconfigservice: AppConfigService,
    private route: ActivatedRoute,
    private router: Router,
    private customerservice: CustomerService,
    private currentorderservice: CurrentOrderService,
    private meta: Meta,
    private title: Title,
    private localeservice: LocaleService,
    private historyservice: StoreHistoryService
  ) {}

  public imageSource: string = 'assets/img/placeholder.png';
  public worktimeString: string = '';
  public orderNowString: string = '';
  public appButtonString: string = '';
  public myProfileButtonString: string = '';
  public isLoading: boolean = true;
  public isError: boolean = false;
  public isSuccess: boolean = false;
  public showProfile: boolean = false;
  public showApp: boolean = false;
  private tableNumber: number = 0;

  errortitle = 'Ops';
  errormessage = 'Er...';
  errorbutton = '!!!';

  ngOnInit(): void {
    this.setErrorMessage();

    this.getData();
  }

  async getData() {
    try {
      this.isLoading = true;

      this.tableNumber = Number(
        this.route.snapshot.paramMap.get('tablenumber')
      );

      if (this.tableNumber < 1) {
        this.isLoading = false;
        this.isSuccess = false;

        return;
      }

      var param = this.route.snapshot.paramMap.get('appname');

      if (param !== null && param !== undefined && param !== '') {
        let result = await this.initializationservice.Initialize(param);

        if (result) {
          this.historyservice.placeEntry();

          this.imageSource = this.currentinfoservice._currentInfo.Icon;

          var placeName = this.appconfigservice.getPlaceName();

          this.title.setTitle(placeName);

          this.meta.updateTag({
            property: 'og:image',
            content: this.imageSource,
          });
          this.meta.updateTag({
            property: 'og:title',
            content: this.appconfigservice.getPlaceName(),
          });
          this.meta.updateTag({ property: 'og:url', content: this.router.url });
          this.meta.updateTag({
            property: 'og:description',
            content: 'Faça seu pedido.',
          });

          this.appButtonString = await this.localeservice.getTranslation(
            'Pages.Storehome.AppButton'
          );
          this.myProfileButtonString = await this.localeservice.getTranslation(
            'Pages.Storehome.ProfileButton'
          );

          if (
            this.workweekservice.isOpen() &&
            this.currentinfoservice.isOpen()
          ) {
            this.worktimeString = String(
              await this.localeservice.getTranslation(
                'Pages.Table.WelcomeMessage'
              )
            ).replace('xXTableNumberXx', String(this.tableNumber));
            this.orderNowString = await this.localeservice.getTranslation(
              'Pages.Storehome.Open.MenuButton'
            );
          } else {
            if (!this.currentinfoservice.isOpen())
              this.worktimeString =
                await this.currentinfoservice.getClosedMessage();
            else
              this.worktimeString = await this.localeservice.getTranslation(
                'Pages.Storehome.Closed.Message'
              );

            this.orderNowString = await this.localeservice.getTranslation(
              'Pages.Storehome.Closed.MenuButton'
            );
          }

          this.showApp = this.appconfigservice.hasApp();
          this.showProfile = this.customerservice.hasCustomerData();

          this.isSuccess = true;

          this.shouldShowOrderSent();
        } else this.worktimeString = '';
      } else this.worktimeString = '';

      this.isLoading = false;
    } catch (error) {
      console.error(error);

      this.isError = true;
      this.isLoading = false;
    }
  }

  tryAgain() {
    this.isError = false;

    this.getData();
  }

  setErrorMessage() {
    var locale = this.getUsersLocale('pt');

    switch (locale) {
      case 'pt':
        this.errortitle = 'Ops';
        this.errormessage =
          'Algo deu errado, verifique sua conexão e tente novamente.';
        this.errorbutton = 'Tentar Novamente';
        break;
      case 'en':
        this.errortitle = 'Ops';
        this.errormessage =
          'Something went wrong, verify your conection and try again.';
        this.errorbutton = 'Try Again';
        break;
      default:
        this.errortitle = 'Ops';
        this.errormessage =
          'Something went wrong, verify your conection and try again.';
        this.errorbutton = 'Try Again';
        break;
    }
  }

  getUsersLocale(defaultValue: string): string {
    if (
      typeof window === 'undefined' ||
      typeof window.navigator === 'undefined'
    )
      return defaultValue;

    const wn = window.navigator as any;

    let lang = wn.languages ? wn.languages[0] : defaultValue;

    lang = lang || wn.language || wn.browserLanguage || wn.userLanguage;

    let langString = String(lang);

    let dashIndx = langString.indexOf('-');

    if (dashIndx > -1) langString = langString.split('-', 2)[0];

    return langString;
  }

  shouldShowOrderSent() {
    if (this.currentorderservice.getShowOrderSent()) {
      var appname = String(this.route.snapshot.paramMap.get('appname'));

      this.router.navigateByUrl('/' + appname + '/ordersent');
    }
  }

  openApp() {
    let link = this.appconfigservice.getAppUrl();

    if (link !== '') window.open(link, '_top');
  }

  orderNow() {
    this.currentorderservice.clear();
    this.currentorderservice.setOrderType(0);
    this.currentorderservice.setTable(this.tableNumber);

    this.router.navigateByUrl(
      '/' + this.initializationservice._appName + '/menuitens'
    );
  }

  seeProfile() {
    this.router.navigateByUrl(
      '/' + this.initializationservice._appName + '/myprofile'
    );
  }

  contactUs() {
    this.router.navigateByUrl('/contactus');
  }
}
